export default (val) => {
  const num = val ? val.replace(/\D/g, "") : "";
  if (num.length !== 11) {
    return num;
  }
  return num.replace(/^(\d{3})(\d{3})?(\d{3})?(\d{2})?/, "***.***.$3-$4");
};
